export default __webpack_public_path__ + "static/media/like.34b31078.svg";